import React from "react";
import { ShieldCheck, BadgeCheck, Star } from "lucide-react";
import { GoogleG } from "./Testimonials";

export const GOOGLE_PROFILE_URL = "https://maps.google.com/?cid=14545544970474787620";

const items = [
  { icon: BadgeCheck, text: "Erlaubnis nach § 34c GewO" },
  { icon: ShieldCheck, text: "Vermögensschadenhaftpflichtversichert" },
];

export const TrustBar = () => (
  <section aria-label="Vertrauen" className="border-y border-brand-100 bg-white" data-testid="trust-bar">
    <div className="max-w-7xl mx-auto px-6 py-5 flex flex-wrap items-center justify-center gap-x-10 gap-y-3">
      {items.map((it) => (
        <div key={it.text} className="inline-flex items-center gap-2.5 text-[14px] font-medium text-brand-900">
          <it.icon className="w-5 h-5 text-emerald-600" />
          {it.text}
        </div>
      ))}
      <a
        href={GOOGLE_PROFILE_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="trust-google-link"
        className="inline-flex items-center gap-2.5 text-[14px] font-medium text-brand-900 hover:text-accent2 transition-colors"
      >
        <GoogleG className="w-5 h-5" />
        <span className="inline-flex items-center gap-1">
          5,0 Sterne bei Google
          <Star className="w-4 h-4 text-[#FBBC05] fill-[#FBBC05]" />
        </span>
      </a>
    </div>
  </section>
);
